module.exports = __webpack_public_path__ + "img/Walnut 1440x480 v2.eb25fbdd.png";